<template>
    <div class="page-content header-clear-medium">
        <div class="card">
            <div class="card-body progress-card">
                <ProgressLearn/>
            </div>
        </div>

        <div class="card">
            <div class="card-body progress-read">
                <div class="text-center">
                    <img src="@/assets/quran.jpg" style="width:120px" alt="" class="img-fluid">
                    <p>BACA QURAN DENGAN MENAMPILKAN KATA YANG BELUM PERNAH DIBACA</p>
                    <button class="btn btn-warning"><i class="bi bi-play-fill"></i> Mulai Membaca</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProgressLearn from '../components/partials/ProgressLearn.vue';
export default {
    name: 'LearnQuran',
    components: {
        ProgressLearn,
    },
}
</script>

<style scoped>
    .progress-card {
        background-color: #6558f5;
    }
    .progress-card h3 {
        color: #f7c325;
    }
    .progress-read {
        background-color: #d3455b;
    }
    .progress-read p {
        color: white;
        margin-bottom: 0;
        margin-top: 5px;
    }
    .border p {
        color: white;
        margin-bottom: 0;
    }
</style>